<template>
    <div>
        <az-back-button :route="{name: 'licitacaoBusca'}" text="Voltar para listagem"></az-back-button>
        <az-container>
            <licitacao-atualizacao-acoes></licitacao-atualizacao-acoes>
            <div class="az-tabs">
                <v-tabs left>
                    <v-tab v-for="aba in abasFiltradas" :key="aba.chave" :to="construirRota(aba.nomeRota)" active-class="v-tabs__item--active secondary--text">
                        {{aba.titulo}}
                    </v-tab>
                </v-tabs>
                <router-view></router-view>
            </div>
        </az-container>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import LicitacaoAtualizacaoAcoes from './acoes/LicitacaoAtualizacaoAcoes'

    export default {
        name: 'LicitacaoAtualizacao',
        components: {LicitacaoAtualizacaoAcoes},
        computed: {
          abas() {
            var rotas = []
            if(this.$store.state.licitacao.acessarTodasAbas) {
                rotas = [{
                    titulo: 'Dados da Licitação',
                    nomeRota: 'licitacaoAtualizacaoDadosGerais'
                  },
                  {
                    titulo: 'Dados do Edital',
                    nomeRota: 'licitacaoAtualizacaoEdital'
                  }, {
                    titulo: 'Itens',
                    nomeRota: 'licitacaoAtualizacaoLotesItens'
                  },
                  {
                    titulo: 'Esclarecimento/Impugnação',
                    nomeRota: 'licitacaoAtualizacaoEsclarecimentoImpugnacao'
                  },
                  {
                    titulo: 'Alterações após publicação',
                    nomeRota: 'licitacaoAtualizacaoEventosPosPublicacao'
                  }
                ]
            } else {
              rotas = [{
                titulo: 'Dados da Licitação',
                nomeRota: 'licitacaoAtualizacaoDadosGerais'
              },

                {
                  titulo: 'Dados do Edital',
                  nomeRota: 'licitacaoAtualizacaoEdital'
                }, {
                  titulo: 'Itens',
                  nomeRota: 'licitacaoAtualizacaoLotesItens'
                },
                {
                  titulo: 'Esclarecimento/Impugnação',
                  nomeRota: 'licitacaoAtualizacaoEsclarecimentoImpugnacao'
                }
              ]
            }

            if(!this.$store.state.licitacao.ehPerfilComprasBR) {
              rotas.push({
                titulo: 'Recurso/Contrarrazão',
                nomeRota: 'licitacaoAtualizacaoRecursoContrarrazao',
                requerExecutarLicitacao: true
              })
            }

            return rotas
          },
          abasFiltradas() {
            return this.abas.filter(aba => !aba.requerExecutarLicitacao || this.$store.state.licitacao.executarLicitacao)
          }
        },
        created() {
            if (this.$route.name !== 'licitacaoAtualizacaoDadosGerais') {
                this.buscarLicitacao(this.$route.params.id)
            }
        },
        methods: {
            construirRota(name) {
                return {
                    name,
                    params: {id: this.$route.params.id},
                    query: this.$route.query
                }
            },
            ...mapActions([actionTypes.BUSCAR_LICITACAO])
        }
    }
</script>